import React, {useEffect, useState} from 'react';
import {
  Chip,
  Autocomplete,
  TextField, Button
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import LargePopper from "../../../../components/Table/assets/LargePopper";
import api from "../../../../services/api";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import ColorizeIcon from "@mui/icons-material/Colorize";
import {SlidingPaneAddNew} from "../../../../components/Page/SlidingPaneAddNew";
import {serviceProviderDriver} from "../../../../schema/serviceProviderDriver";

export default function SelectDriverField({
                                             params,
                                            type,
                                            onChangeValue,
                                           }: {
  params: any;
  type?: any;
  onChangeValue?: (value:any) => void;
}) {
  const [selectOptions, setSelectOptions] = useState<[]>([]);
  const [loading, setLoading] = useState(false);
  const transformedValue = params.value;
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: serviceProviderDriver,
    row: {},
  });

  const fetchSelectOptions = async (searchText: string) => {
    setLoading(true);
    const searchParams = new URLSearchParams({
      searchValue: searchText,
    });
    api.get(`/service-provider/service-reservation/${params?.row?.service_reservation_id}/drivers`, searchParams).then((result: any) => {
      /*result.unshift({id: 0, name: '', isButton: true});*/
      setSelectOptions(result);
      setLoading(false);
    });
  };

  const onChange = (event: any, value: any) => {

    if (value?.isButton) {
      setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: params.row});
    } else {
      if (type && type === 'card'){
        if (onChangeValue){
          onChangeValue(value);
        }
      }else{
        params.api.setEditCellValue({
          id: params.id,
          field: params.field,
          value: value,
        });
      }
    }

  };

  const [searchText, setSearchText] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {

    if (searchText === '') {
      setFilteredOptions(selectOptions); // Ha nincs keresés, minden opció látható
    } else {
      setFilteredOptions(
        selectOptions.filter((option: any) => {
          const nameMatches = option?.name
            ? option.name.toLowerCase().includes(searchText.toLowerCase())
            : false;

          const addressMatches = option?.address_line1
            ? option.address_line1.toLowerCase().includes(searchText.toLowerCase())
            : false;

          return nameMatches || addressMatches;
        })
      );
    }
  }, [searchText, selectOptions]);

  return (
    <>
      <Autocomplete
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: '0',
            paddingRight: '15px !important',
          },
          '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
            paddingTop: '0px',
            paddingBottom: '0px',
          },
          '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
            right: '0px',
          },
        }}
        componentsProps={{
          clearIndicator: {
            sx: {
              display: 'none',
            },
          },
        }}
        PopperComponent={LargePopper}
        freeSolo
        loading={loading}
        onOpen={() => fetchSelectOptions('')}
        fullWidth={true}
        size="small"
        options={filteredOptions}
        getOptionLabel={(option) => option?.name}
        getOptionKey={(option) => option?.id}
        /*isOptionEqualToValue={(option, value) => {
          return option.id === value.id;
        }}*/
        renderOption={(props: any, option: any) => {
          return (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.isButton ? (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  size={'small'}
                  fullWidth
                >
                  Add new
                </Button>
              ) : (
                <>
                  {(option?.color && typeof option?.color === 'string' && !option?.isButton) ? (
                    <Chip
                      style={{
                        background: `#${option?.color}`,
                        color: '#fff',
                      }}
                      icon={
                        <ColorizeIcon color={'disabled'} sx={{ color: 'white' }} />
                      }
                      label={`#${option.name}`}
                    />
                  ) : (
                    <>{option?.name ? option.name : '-'}</>
                  )}
                </>
              )}
            </Box>
          );
        }}
        value={transformedValue}
        onChange={(event, newValue) => {
          onChange(event, newValue);
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              size="small"
            />
          );
        }}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            setSearchText(newInputValue);
          }
        }}
        disabled={transformedValue?.disabled}
      />


      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={
              openedSlidingPaneAddNew?.hasOwnPane
                ? undefined
                : openedSlidingPaneAddNew?.row?.id
            }
            onSubmit={() => {
              setOpenedSlidingPaneAddNew({
                schema: serviceProviderDriver,
                row: {},
              });
            }}
            propertiesFromTable={
              openedSlidingPaneAddNew?.row ? openedSlidingPaneAddNew?.row : {}
            }
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({
                schema: serviceProviderDriver,
                row: {},
              });
            }}
          />
        </>
      )}


    </>
  );
}
